// Application Constants

// ===========================================
// 🎯 ENVIRONMENT SELECTION (Uncomment ONE)
// ===========================================

// 🏠 LOCAL DEVELOPMENT
//export const API_BASE_URL = 'http://localhost:3001';



// 🎯 CUSTOM SERVER
export const API_BASE_URL = 'https://route.mobiapi.net';

export const API_ENDPOINTS = {
  SOLVE_VRP: '/api/solve',

} as const;

export const DEFAULT_VALUES = {
  VEHICLE_CAPACITY: 200,
  NUM_VEHICLES: 5,
  MAP_CENTER: [49.649205, 8.470092] as [number, number], // Default depot location (Mannheim, Germany)
  MAP_ZOOM: 12,
} as const;

export const COLORS = {
  PRIMARY: '#667eea',
  SECONDARY: '#764ba2',
  SUCCESS: '#10b981',
  WARNING: '#f59e0b',
  ERROR: '#ef4444',
  INFO: '#3b82f6',
} as const;

export const ROUTE_COLORS = [
  '#ef4444', // red
  '#3b82f6', // blue
  '#10b981', // green
  '#f59e0b', // amber
  '#8b5cf6', // purple
  '#ec4899', // pink
  '#14b8a6', // teal
  '#f97316', // orange
  '#06b6d4', // cyan
  '#84cc16', // lime
  '#f43f5e', // rose
  '#a855f7', // violet
  '#22d3ee', // cyan-400
  '#fbbf24', // amber-400
  '#fb923c', // orange-400
  '#4ade80', // green-400
  '#60a5fa', // blue-400
  '#c084fc', // purple-400
  '#f472b6', // pink-400
  '#2dd4bf', // teal-400
] as const;
